import { api_url } from "./constantInformation";

function get_export_lineups_url(mylineups) {
  if (mylineups === true) {
    return api_url + "lineups/export/mylineups";
  } else {
    return api_url + "lineups/export";
  }
}
function get_auto_lineups_url() {
  return api_url + "lineups/auto";
}
export { get_export_lineups_url, get_auto_lineups_url };
